import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-icon",
  "use": "plus-icon-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-icon\">\n    <path d=\"M12 23.5C12.5523 23.5 13 23.0523 13 22.5V13.5H22C22.5523 13.5 23 13.0523 23 12.5C23 11.9477 22.5523 11.5 22 11.5H13V2.5C13 1.9477 12.5523 1.5 12 1.5C11.4477 1.5 11 1.9477 11 2.5V11.5H2C1.44772 11.5 1 11.9477 1 12.5C1 13.0523 1.44772 13.5 2 13.5H11V22.5C11 23.0523 11.4477 23.5 12 23.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol